import { render, staticRenderFns } from "./BootstrapRule.vue?vue&type=template&id=bafcc40c"
import script from "./BootstrapRule.vue?vue&type=script&lang=js"
export * from "./BootstrapRule.vue?vue&type=script&lang=js"
import style0 from "./BootstrapRule.vue?vue&type=style&index=0&id=bafcc40c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports